/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  manufacturerIdLabel,
  nameLabel,
  rebateProgramLabel,
  quarterRangeLabel,
  URAUsedLabel,
  accountReceivableNDCDatailLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
// import { accountReceivableNDCDetailAllColumns } from '../tablehead';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { accountReceivableNDCDetailColumns } from '../tablehead';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
import { exportPDF } from './ExportPDF';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const AccRecNDCDetailAll = (props) => {
  const dispatch = useDispatch();

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [pinned, setPinned] = React.useState();
  const getAllAccRecNDCList = useSelector(
    (state) =>
      state?.sharedState?.AccRecNDCDetailAllReducer?.getAllAccRecNDCDetailList
  );
  const NDCList = useSelector(
    (state) => state?.sharedState?.AccRecNDCDetailAllReducer?.ndcDetailList
  );
  const getAllQuarterValue = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.getAllQuarterValue
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (!filterApply) {
      const data = [
        {
          originalInvoiceAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaloriginalInvoiceAmount,
          currentInvoiceAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalcurrentInvoiceAmount,
          currentRebateOffsetAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalcurrentRoa,
          baseStateRebateAmount: sum('baseStateRebateAmount'),
          principalPaid:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalprincipalPaid,
          offsetPaidAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaloffsetPaidAmount,
          baseStatePaidAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalbaseStatePaidAmount,
          principalDue:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalprincipalDue,
          offsetDue:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaloffsetDue,
          baseStateAmountDue:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalbaseStateAmountDue,
          interestCalculated:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalinterestCalculated,
          interestPaid:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalinterestPaid,
          interestDue:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalinterestDue,
          totalAmountDue:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaltotalAmountDue,
          disputedAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaldisputedAmount,
          originalReimburseAmountOnClaims:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaloriginalReimburseAmountOnClaims,
          originalOtherpaymentsfromClaims:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finaloriginalOtherpaymentsfromClaims,
          currentReimburseAmountOnClaims:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalcurrentReimburseAmountOnClaims,
          currentOtherPaymentsfromClaims:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalcurrentOtherPaymentsfromClaims,
          federalAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalfederalAmount,
          stateAmount:
            getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
              ?.finalstateAmount,
          drugName: 'Total:',
          actions: 'hide',
          originalUnits: '',
          currentUnits: '',
          unitsPaid: '',
          unitsUnpaid: '',
          unitsDisputed: '',
          originalURA: '',
          currentURA: '',
          familyPlanningindicator: null,
          isBottomRow: true,
        },
      ];
      setPinned(data);
    } else {
      const data = [
        {
          originalInvoiceAmount: sum('originalInvoiceAmount'),
          currentInvoiceAmount: sum('currentInvoiceAmount'),
          currentRebateOffsetAmount: sum('currentRoa'),
          principalPaid: sum('principalPaid'),
          offsetPaidAmount: sum('offsetPaidAmount'),
          baseStatePaidAmount: sum('baseStatePaidAmount'),
          principalDue: sum('principalDue'),
          offsetDue: sum('offsetDue'),
          baseStateAmountDue: sum('baseStateAmountDue'),
          interestCalculated: sum('interestCalculated'),
          interestPaid: sum('interestPaid'),
          interestDue: sum('interestDue'),
          totalAmountDue: sum('totalAmountDue'),
          disputedAmount: sum('disputedAmount'),
          originalReimburseAmountOnClaims: sum(
            'originalReimburseAmountOnClaims'
          ),
          originalOtherpaymentsfromClaims: sum(
            'originalOtherpaymentsfromClaims'
          ),
          currentReimburseAmountOnClaims: sum('currentReimburseAmountOnClaims'),
          currentOtherPaymentsfromClaims: sum('currentOtherPaymentsfromClaims'),
          federalAmount: sum('federalAmount'),
          baseStateRebateAmount: sum('baseStateRebateAmount'),
          stateAmount: sum('stateAmount'),
          drugName: 'Total:',
          actions: 'hide',
          originalUnits: '',
          currentUnits: '',
          unitsPaid: '',
          unitsUnpaid: '',
          unitsDisputed: '',
          originalURA: '',
          currentURA: '',
          familyPlanningindicator: null,
          isBottomRow: true,
        },
      ];
      setPinned(data);
    }
  }, [filterApply, filteredRows]);
  // ag-grid frame work component
  const frameworkComponents = {
    ActionRenderer: (cellInfo) => {
      return (
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          displayBy="ndcdetail"
          selectPgm
          extraData={{ ...NDCList, quarter: getAllQuarterValue || NDCList.qtr }}
          getAllQuarterValue={getAllQuarterValue}
        />
      );
    },
    FullNameRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return <NameTooltipComp data={cellInfo} />;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    CheckboxRenderer: (cellInfo) => {
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            value={
              cellInfo.data.familyPlanningindicator === 0
                ? false
                : true || false
            }
            disabled
            onChange={(e, val) => {}}
            checked={
              cellInfo.data.familyPlanningindicator === 0
                ? false
                : true || false
            }
          />
        </div>
      );
    },
  };
  // on grid ready for table
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const customPDFExport = (fileName) => {
    const reportName = accountReceivableNDCDatailLabel;
    const rowdata =
      getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse?.acctRecvMfgNDCDetailAllRpcResponseVO?.map(
        (item) => {
          item.originalUnits = item.originalUnits
            ? parseFloat(item.originalUnits).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.currentUnits = item.currentUnits
            ? parseFloat(item.currentUnits).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsPaid = item.unitsPaid
            ? parseFloat(item.unitsPaid).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsUnpaid = item.unitsUnpaid
            ? parseFloat(item.unitsUnpaid).toFixed(3)
            : parseFloat(0).toFixed(3);
          item.unitsDisputed = item.unitsDisputed
            ? parseFloat(item.unitsDisputed).toFixed(3)
            : parseFloat(0).toFixed(3);
          return item;
        }
      )
        ? getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse?.acctRecvMfgNDCDetailAllRpcResponseVO?.map(
            (item) => {
              item.originalUnits = item.originalUnits
                ? parseFloat(item.originalUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.currentUnits = item.currentUnits
                ? parseFloat(item.currentUnits).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.unitsPaid = item.unitsPaid
                ? parseFloat(item.unitsPaid).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.unitsUnpaid = item.unitsUnpaid
                ? parseFloat(item.unitsUnpaid).toFixed(3)
                : parseFloat(0).toFixed(3);
              item.unitsDisputed = item.unitsDisputed
                ? parseFloat(item.unitsDisputed).toFixed(3)
                : parseFloat(0).toFixed(3);
              return item;
            }
          )
        : [];
    const columns = accountReceivableNDCDetailColumns;

    const customObj = {
      mfgId: NDCList && NDCList.mfgId,
      mfgName: NDCList.mfgName,
      quarter: NDCList?.getQuarterValue || NDCList?.qtr,

      URAUsed: NDCList?.uraInfo,
    };
    const pinnedBottomRowData =
      getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
        ?.acctRecvMfgNDCDetailAllRpcResponseVO?.length > 0
        ? pinned
        : undefined;

    const NDCBalance = {
      balanceDue: false,
      overidden: false,
      paidInFull: false,
    };
    exportPDF(
      rowdata,
      fileName,
      logInUser,
      columns,
      customObj,
      NDCBalance,
      pinnedBottomRowData,
      reportName,
      dispatch
    );
  };
  return (
    <div className="tabs-container ARScreen" data-testid="AccRecNDCDetailAll">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2="Accounts Receivable NDC Detail"
      />
      {!fullScreenView && (
        <div className="row">
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="manufacturerId"
                      label={manufacturerIdLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={NDCList?.mfgId}
                    />
                  </div>
                </div>
                <div className="col-3col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="name"
                      label={nameLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={NDCList?.mfgName}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="quarter"
                      label={quarterRangeLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={getAllQuarterValue || NDCList?.qtr}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value="All | All Rebate Programs"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={NDCList?.uraInfo}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={accountReceivableNDCDetailColumns.filter(
              (obj) =>
                [
                  'Most Recent Quarter',
                  'Most Recent URA',
                  'Current URA',
                  'Original URA',
                  'Current ROA',
                  'Current Rebate Offset Amount',
                  'Status',
                ].indexOf(obj.headerName) === -1
            )}
            rowData={
              getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse?.acctRecvMfgNDCDetailAllRpcResponseVO?.map(
                (item) => {
                  item.originalUnits = item.originalUnits
                    ? parseFloat(item.originalUnits).toFixed(3)
                    : parseFloat(0).toFixed(3);
                  item.currentUnits = item.currentUnits
                    ? parseFloat(item.currentUnits).toFixed(3)
                    : parseFloat(0).toFixed(3);
                  item.unitsPaid = item.unitsPaid
                    ? parseFloat(item.unitsPaid).toFixed(3)
                    : parseFloat(0).toFixed(3);
                  item.unitsUnpaid = item.unitsUnpaid
                    ? parseFloat(item.unitsUnpaid).toFixed(3)
                    : parseFloat(0).toFixed(3);
                  item.unitsDisputed = item.unitsDisputed
                    ? parseFloat(item.unitsDisputed).toFixed(3)
                    : parseFloat(0).toFixed(3);
                  return item;
                }
              )
                ? getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse?.acctRecvMfgNDCDetailAllRpcResponseVO?.map(
                    (item) => {
                      item.originalUnits = item.originalUnits
                        ? parseFloat(item.originalUnits).toFixed(3)
                        : parseFloat(0).toFixed(3);
                      item.currentUnits = item.currentUnits
                        ? parseFloat(item.currentUnits).toFixed(3)
                        : parseFloat(0).toFixed(3);
                      item.unitsPaid = item.unitsPaid
                        ? parseFloat(item.unitsPaid).toFixed(3)
                        : parseFloat(0).toFixed(3);
                      item.unitsUnpaid = item.unitsUnpaid
                        ? parseFloat(item.unitsUnpaid).toFixed(3)
                        : parseFloat(0).toFixed(3);
                      item.unitsDisputed = item.unitsDisputed
                        ? parseFloat(item.unitsDisputed).toFixed(3)
                        : parseFloat(0).toFixed(3);
                      return item;
                    }
                  )
                : []
            }
            pinnedBottomRowData={
              getAllAccRecNDCList?.acctRecvMfgNDCDetaillServiceResonse
                ?.acctRecvMfgNDCDetailAllRpcResponseVO?.length > 0
                ? pinned
                : undefined
            }
            exportFile
            // isScrollOn
            animateRows
            sideBar={false}
            fileName={accountReceivableNDCDatailLabel}
            customPDFExport={customPDFExport}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
    </div>
  );
};

export default AccRecNDCDetailAll;
